import { useEffect } from "react";
import { SERVER_URL } from "../../../config/config";
import { SmugglingActionType } from "../../../constants/enum/enum";
import { SSE_HEADER } from "../../../constants/sse";
import { parseNarcsBuyInfo, parseNarcsSellInfo } from "../../../helper/game";

const useNarcsSSE = (
  account: string,
  onSuccess: (
    actionType: SmugglingActionType,
    cashAmount: number,
    xpAmount: number
  ) => void,
  onCaught: () => void,
  onFailed: () => void,
  _: () => void
) => {
  useEffect(() => {
    const eventSource = new EventSource(`${SERVER_URL}/event/smuggle`);
    eventSource.onmessage = (e) => {
      if (e.data.includes("welcome")) {
      } else if (e.data.includes("eventName")) {
        const event = JSON.parse(e.data);

        if (event.eventName === SSE_HEADER.SMUGGLE.NARCS_BUY) {
          const buyInfo = parseNarcsBuyInfo(event.data);

          if (buyInfo.buyer.toLowerCase() === account.toLowerCase()) {
            if (buyInfo.isSuccess) {
              onSuccess(
                SmugglingActionType.Buy,
                buyInfo.cashAmount,
                buyInfo.xpPoint
              );
              return;
            }

            if (buyInfo.isJailed) {
              onCaught();
              return;
            }

            if (!buyInfo.isSuccess && !buyInfo.isJailed) {
              onFailed();
              return;
            }
          }
        } else if (event.eventName === SSE_HEADER.SMUGGLE.NARCS_SELL) {
          const sellInfo = parseNarcsSellInfo(event.data);

          if (sellInfo.seller.toLowerCase() === account.toLowerCase()) {
            if (sellInfo.isSuccess) {
              onSuccess(
                SmugglingActionType.Sell,
                sellInfo.cashAmount,
                sellInfo.xpPoint
              );
              return;
            }

            if (sellInfo.isJailed) {
              onCaught();
              return;
            }

            if (!sellInfo.isSuccess && !sellInfo.isJailed) {
              onFailed();
              return;
            }
          }
        }
      }
    };
    return () => {
      eventSource.close();
    };
  }, [account, onCaught, onFailed, onSuccess]);
};

export default useNarcsSSE;
